// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageLoader_loader__iFGnT"};